import React from 'react';
import Deal1 from "./Deal1";
import Slide from './Slide';
import Photo from "./Photo";
import Country from "./Country";
import AD from "./AD";
import Cos from "./Cos";

const Main = () => {
    return (

        <div>
    <Slide />
    <Cos />
    <Country />
    <Photo/>
    <Deal1/>
   <AD/>
        </div>
    );
};

export default Main;
